import React, { useState, useEffect, useCallback,useRef } from "react";
import {
  Center,
  Stack,
  HStack,
  AspectRatio,
  Heading,
  Text,
  Box,
  Pressable,
  Modal,
  Button,
  Avatar,
  VStack,
  View,
  // FlatList,
  Image,
} from "native-base";
import {ScrollView, Dimensions,Platform } from 'react-native';
// import { FlatList } from "react-native-gesture-handler";
import { GlobalStyles } from "../constants/styles";
import { MaterialIcons } from "@expo/vector-icons";
import { Linking } from "react-native";
import { Image as NativeImage } from "react-native";
import { Video } from 'react-native-video';
import ConfigureSettingsPopup from "./ConfigureSettingsPopup";
import ClipboardPopup from "./ClipboardPopup";
import { Ionicons } from "@expo/vector-icons";
import RenderHtml from 'react-native-render-html';  // Import RenderHtml
// import { getDisplayDate } from "../utils/general";
import Clipboard from '@react-native-clipboard/clipboard';


const FeedCardNew = ({ data, showViewCount, setSelectedPost }) => {
  // console.log(data);
  const [imageUrl, setImageUrl] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [detailPopUp, setDetailPopUp] = useState(false);
  // const [saveButtonText, setSaveButtonText] = useState(data.is_saved ? "UnSave" : "Save");

  const [isClipboardPopupOpen, setIsClipboardPopupOpen] = useState(false);
  const screenWidth = window?.innerWidth > 600 ? 600 : 330 ;  

  const openClipboardPopup = () => {
    setIsClipboardPopupOpen(true);
  };

  const closeClipboardPopup = () => {
    setIsClipboardPopupOpen(false);
  };

  const shareClipboardPopup = async (selectedFriendIds) => {
    console.log(selectedFriendIds);
  };

  const openModal = (obj) => {
    setModalVisible(true);
    setImageUrl(data.post_urls[obj]);
    // updateAdViews(obj);
  };

  const closeModal = () => {
    setImageUrl("");
    setModalVisible(false);
  };

  function getAvatarChar(fullName) {
    let nameShortCode = "";
    if (fullName && fullName.split(" ").length > 1) {
      nameShortCode =
        fullName.split(" ")[0].charAt(0).toUpperCase() +
        fullName.split(" ")[1].charAt(0).toUpperCase();
    } else {
      nameShortCode = fullName.charAt(0).toUpperCase();
    }
    return nameShortCode;
  }
  

  const handleChange = useCallback(async (value) => {
    setDetailPopUp(false);
  }, []);
  
  
  const isHtmlContent = (content) => {
    const regex = /<[^>]*>/g;  // Check for HTML tags
    return regex.test(content);
  };

  const processTickText = (text = "") => {
    if (typeof text !== "string") return null;
    const urlRegex = /(https?:\/\/[^\s]+)/g; // Regex to extract URL
    const parts = text.split(urlRegex); // Split text into URL and non-URL parts
  
    return parts.map((part, index) =>
      urlRegex.test(part) ? (
        <Text
          key={index}
          style={{ color: "blue", textDecorationLine: "underline" }}
          onPress={() => Linking.openURL(part)}
        >
          {part}
        </Text>
      ) : (
        <Text key={index}>{part}</Text>
      )
    );
  };
  const cleanHtmlContent = (html) => {
    return html.replace(/<p>(\s|&nbsp;|<br>)*<\/p>/gi, "") // Remove empty p

  };
  
  const processTickContent = (content) => {
    if (isHtmlContent(content)) {
      // If it's HTML content, process it accordingly
      return (
        <RenderHtml
          source={{ html: cleanHtmlContent(content) }}
          baseStyle={{
            fontSize: 18,
            fontFamily: GlobalStyles.text.fontFamily,
            color: '#000',
            marginTop: 4,
          }}
          tagsStyles={{
            a: {
              color: 'blue',
              textDecorationLine: 'underline',
            },
            p: {
              marginTop: 10, // Adds space above paragraphs
              marginBottom: 10, // Adds space below paragraphs
              lineHeight: 24, // Improves readability
            },
          }}
          defaultTextProps={{ selectable: true }}
        />
      );
    } else {
      // If it's plain text, process it using processTickText
      return (
        <Text
          fontWeight="400"
          fontSize="18"
          mt={1}
          fontFamily={GlobalStyles.text.fontFamily}
          isSelectable
        >
          {processTickText(content)}
        </Text>
      );
    }
  };

  function getDisplayDate(year, month, day) {
    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    let compDate = new Date(year, month - 1, day); // month - 1 because January == 0
    let diff = today.getTime() - compDate.getTime(); // get the difference between today(at 00:00:00) and the date
    let stringDate = compDate.toDateString().split(" ");
    if (compDate.getTime() > today.getTime()) {
      return stringDate[1] + " " + stringDate[2];
    } else if (compDate.getTime() == today.getTime()) {
      return "Today";
    } else if (diff <= 24 * 60 * 60 * 1000) {
      return "Yesterday";
    } else {
      if (year != today.getFullYear()) {
        return stringDate[1] + " " + stringDate[2] + " " + stringDate[3];
      } else {
        return stringDate[1] + " " + stringDate[2];
      }
    }
  }
  const stripHtml = (html) => {
    return html?.replace(/<[^>]*>?/gm, "").trim();
  };
  const copyContent = (data) => {
    const text = stripHtml(data.tick || ""); // Optional sanitization
    const imageUrl = data.post_urls?.join("\n") || "";
    const combinedContent = `${text}\n\n${imageUrl}`;
  
    try {
      if (typeof window !== "undefined" && window.navigator?.clipboard) {
        // Web
        navigator.clipboard.writeText(combinedContent).then(() => {
          toast.show({
            render: () => (
              <Toast
                color={GlobalStyles.colors.green}
                message={"Copied to clipboard!"}
              />
            ),
            placement: "top",
          });
        });
      } else {
        // React Native
        Clipboard.setString(combinedContent);
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message={"Copied to clipboard!"}
            />
          ),
          placement: "top",
        });
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={"Failed to copy content!"}
          />
        ),
        placement: "top",
      });
    }
  };
  const copyDetail = (data) => {
    const text = stripHtml(data.detail || ""); // Optional sanitization

    const combinedContent = `${text}`;
  
    try {
      if (typeof window !== "undefined" && window.navigator?.clipboard) {
        // Web
        navigator.clipboard.writeText(combinedContent).then(() => {
          toast.show({
            render: () => (
              <Toast
                color={GlobalStyles.colors.green}
                message={"Copied to clipboard!"}
              />
            ),
            placement: "top",
          });
        });
      } else {
        // React Native
        Clipboard.setString(combinedContent);
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message={"Copied to clipboard!"}
            />
          ),
          placement: "top",
        });
      }
    } catch (error) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message={"Failed to copy content!"}
          />
        ),
        placement: "top",
      });
    }
  };
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);
  const carouselH        = (screenWidth * 2) / 3;  

    /* ---------- helpers ---------- */
   /* update active dot while swiping */
   const handleScroll = (e) => {
    const x = Platform.OS === "web"
      ? e.target.scrollLeft
      : e.nativeEvent.contentOffset.x;
      const index = Math.floor(x / screenWidth);
      if (index !== activeIndex) {
        setActiveIndex(index);
      }
  };

  /* jump to requested slide (dot click) */
  const jumpTo = (idx) => {
    const offset = idx * screenWidth;
    if (Platform.OS === "web") {
      scrollRef.current?.scrollTo({ left: offset, behavior: "smooth" });
    } else {
      scrollRef.current?.scrollTo({ x: offset, animated: true });
    }
  };

  const imgs = data?.post_urls ?? [];
  const isVideo = (url = "") => {
    const cleanUrl = url.split("?")[0]; // remove query params
    return /\.(mp4|mov|webm|mkv)$/i.test(cleanUrl);
  };
  useEffect(async () => {
    console.log(window?.innerWidth || yourDefaultWidth);
  }, []);

  return (
    <>
      <Modal
        size="xl"
        isOpen={modalVisible}
        onClose={closeModal}
        animationType="slide"
        transparent
      >
        <Modal.Content
          backgroundColor={"#43464b"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Modal.CloseButton />
          {imageUrl && (
            <Image
              w={[500, 700, 900]}
              h={[500, 700, 900]}
              source={{ uri: imageUrl }}
              resizeMode="contain"
              // style={{ width: "150%", height: "150%", resizeMode: "contain" }}
            />
          )}
        </Modal.Content>
      </Modal>
      <Center
        m={2}
        _text={{
          color: "warmGray.50",
          fontWeight: "medium",
        }}
      >
        <Box alignItems="center">
          <Box
            rounded="lg"
            // overflow="hidden"
            borderColor={GlobalStyles.colors.mustard}
            borderWidth="1"
            // _dark={{
            //   borderColor: "coolGray.600",
            //   backgroundColor: "gray.700",
            // }}
            // _web={{
            //   shadow: 2,
            //   borderWidth: 0,
            //   borderColor: GlobalStyles.colors.mustard
            // }}
            // _light={{
            //   backgroundColor: "gray.50",
            //   borderColor: GlobalStyles.colors.mustard
            // }}
          >
            <Stack p="4" w={[330, 450, 600]}>
              <Stack alignSelf="flex-end">
                <Text fontSize="xs">
                  {data?.created_at
                    ? getDisplayDate(
                        data.created_at.split("-")[0],
                        data.created_at.split("-")[1],
                        data.created_at.split("-")[2]
                      )
                    : "few days ago"}
                </Text>
              </Stack>
              <Stack space={2}>
                <HStack ml="-2" mt={-5}>
                  <Avatar
                    size="sm"
                    source={{
                      uri: data.logo_url ? data.logo_url : "",
                    }}
                    bg={GlobalStyles.colors.blue}
                  >
                    {data?.name
                      ? getAvatarChar(data.name)
                      : getAvatarChar("")}
                  </Avatar>
                  <Heading
                    mt={2}
                    size="sm"
                    fontFamily={GlobalStyles.text.fontFamily}
                  >
                    {" "}
                    <Text fontSize={18}>
                      {data?.name ? data.name : ""}
                    </Text>
                  </Heading>
                </HStack>
              </Stack>
              <Text
                selectable={true}
                style={{
                  userSelect: 'text', // ✅ Web-specific fix
                }}
                fontWeight="400"
                fontSize="18"
                mt={1}
                fontFamily={GlobalStyles.text.fontFamily}
                
                // noOfLines={5}
              >
                {processTickContent(data?.tick)}
                {/* Bengaluru (also called Bangalore) is the center of India's
                high-tech industry. The city is also known for its parks and
                nightlife. */}
              </Text>
            </Stack>
            <Box>
              {/* ---------- SLIDE STRIP ---------- */}
              {Platform.OS === "web" ? (
                <div
                  ref={scrollRef}
                  onScroll={handleScroll}
                  style={{
                    display: "flex",
                    overflowX: "auto",
                    width: screenWidth,
                    scrollSnapType: "x mandatory",
                    scrollBehavior: "smooth",
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                  }}
                >
                  {imgs.map((url, idx) => (
                    <div
                      key={idx}
                      style={{
                        width: screenWidth,
                        height: carouselH,
                        scrollSnapAlign: "center",
                        flexShrink: 0,
                      }}
                      onClick={() => openModal?.(idx)}
                    >
                      {isVideo(url) ? (
                        <video
                          src={ url }
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 8,
                            display: "block",
                          }}
                          controls
                        />
                      ) : (
                        <img
                          src={ url }
                          alt={`media-${idx}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 8,
                            display: "block",
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <ScrollView
                  ref={scrollRef}
                  horizontal
                  pagingEnabled
                  onScroll={handleScroll}
                  scrollEventThrottle={16}
                  showsHorizontalScrollIndicator={false}
                  style={{ width: screenWidth, height: carouselH }}
                >
                  {imgs.map((url, idx) => (
                    <Pressable key={idx} onPress={() => openModal?.(idx)}>
                      <Box width={screenWidth} height={carouselH}>
                        {isVideo(url) ? (
                          <Video
                            src={{ uri: url }}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: 8,
                              display: "block",
                            }}
                            controls
                          />
                        ) : (
                          <img
                            src={{ uri: url }}
                            alt={`media-${idx}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: 8,
                              display: "block",
                            }}
                          />
                        )}
                      </Box>
                    </Pressable>
                  ))}
                </ScrollView>
              )}

              {/* ---------- DOTS ---------- */}
              {imgs.length > 1 && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    marginTop: 8,
                  }}
                >
                  {imgs.map((_, idx) => (
                    <Pressable key={idx} onPress={() => jumpTo(idx)}>
                      <Box
                        width={2}
                        height={2}
                        borderRadius="50%"
                        mx={1}
                        bg={idx === activeIndex ? "#002061" : "#E5E4E2"}
                      />
                    </Pressable>
                  ))}
                </View>
              )}
            </Box>

            <HStack p="1" w={[330, 450, 600]} justifyContent="space-between">
              <Stack w={[window?.innerWidth > 600 ? 100:70]}>
                <Button
                  leftIcon={
                    <MaterialIcons
                      name="delete-outline"
                      size={24}
                      color="black"
                    />
                  }
                  size="sm"
                  variant="unstyled"
                  onPress={() => {
                    setSelectedPost(data);
                  }}
                >
                  {"Delete"}
                </Button>
              </Stack>
              {/* <Stack w={[window?.innerWidth > 600 ? 100:70]}>
                <Button
                  leftIcon={
                    <MaterialIcons name="content-copy" size={24} color="black" />
                  }
                  size="sm"
                  variant="unstyled"
                  onPress={() => copyContent(data)}
                >
                  {"Copy"}
                </Button>
              </Stack> */}
              <Stack w={[window?.innerWidth > 600 ? 100:70]}>
                <Button
                  isDisabled={!data.detail}
                  leftIcon={
                    <Image
                      source={require("../../assets/detail.png")}
                      alt="Save"
                      size="7"
                    />
                    // <MaterialIcons name="list-alt" size={24} color="black" />
                  }
                  size="sm"
                  variant="unstyled"
                  onPress={() => {
                    setDetailPopUp(true);
                  }}
                >
                  {"Detail"}
                </Button>
              </Stack>
              <Stack w={[window?.innerWidth > 600 ? 100:70]}>
                <Button
                  leftIcon={
                    // <Image
                    //   source={require("../../assets/share.png")}
                    //   alt="Save"
                    //   size="7"
                    // />
                    <MaterialIcons name="share" size={24} color="black" />
                  }
                  size="sm"
                  variant="unstyled"
                  onPress={openClipboardPopup}
                >
                  {"Share"}
                </Button>
              </Stack>
             
            </HStack>
          </Box>
        </Box>
      </Center>

      <ClipboardPopup
        isOpen={isClipboardPopupOpen}
        onClose={closeClipboardPopup}
        onShare={shareClipboardPopup}
        url={window.location.host + "/invite/feed/" + data.id}
        friends={[]}
      />

      {detailPopUp ? (
        <ConfigureSettingsPopup
          heading="Detail"
          body={processTickContent(data.detail || "No details available")}
          data={detailPopUp}
          onChange={handleChange}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default FeedCardNew;
